
import React, { useState, useEffect, useCallback } from "react";
import cn from "classnames";
import { getTime, getDate } from "components/common/dateTime";
import styles from "../../components/battery/Battery.module.scss";
import BatteryAnalytics from "../../components/battery/BatteryAnalytics";
import BatterySwappingHistory from "../../components/battery/BatterySwappingHistory";
import LocalStorageService from "services/tokenlocalstorage.service";
import Master from "screen/Master";
import { getRequest } from "../../services/axiosBaseClient";
import BatteryInformation from "../../components/battery/BatteryInformation";
import BatteryTracking from "../../components/battery/BatteryTracking";
function BatteryView(props) {
  const filterInitialValue = {
    startDate: "",
    endDate: "",
    siteId: "",
    chargerId: "",
    state: "",
    city: "",
    zoneId: "",
  };
  var socValue;

  const batteryId = props?.match?.params?.id;
  const batterySerial = props?.match?.params?.batterySerial;
  const batteryName = props?.match?.params?.batteryName;

  const [userRole, setUserRole] = useState("");
  const [filter, setFilter] = useState(filterInitialValue);
  const [tab, setTab] = useState(1);
  const [header, setHeader] = useState([]);
  const [socHeaderValue, setSocHeaderValue] = useState("");
  const [batteryStatus, setBatteryStatus] = useState("");
  const [purchaseDate, setPurchaseDate] = useState("");

  const getHeaderInformation = useCallback(async (id) => {
    await getRequest("bss/getBatteryHeaderInfo?batteryId=" + id).then((res) => {
      if (res && res?.data) {
        setPurchaseDate(res?.data?.dateOfPurchase?.split(" "));
        setHeader(res?.data);
        socValue = res?.data?.soc.split(".");
        setSocHeaderValue(socValue[0]);
        setBatteryStatus(res?.data?.status);
      }
    });
  }, []);

  useEffect(() => {
    getHeaderInformation(batteryId);
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0 });
    const headerFilterObj = JSON.parse(LocalStorageService.get("headerFilter"));
    if (headerFilterObj !== null) {
      filter.state = headerFilterObj.state;
      filter.city = headerFilterObj.city;
      filter.zoneId = headerFilterObj.zoneId;
    }

    //getTime(24);
    // getSites();
    // getSiteStatus();
    // getSwapStatus();
    // getBatteriesStatus();
    // getAlertStatus();
    // getEnergyGraph(filter);
    // getFaultGraph(filter);
    // getSwappingGraph(filter);
    setUserRole(LocalStorageService.get("user-role"));
    localStorage.setItem("activeTabCount", "zoneAsset");
  }, []);

  return (
    <div>
      {/* className={cn(styles.flex, styles.flex_layout)} */}

      <h2 className={cn(styles.medium_title, styles.medium_title_layout)}>
        {"Battery"}
      </h2>

      <div className={cn(styles.block8, styles.block8_layout)}>
        <div className={cn(styles.block8_item)}>
          <div className={cn(styles.block23, styles.block23_layout)}>
            <div className={cn(styles.box10, styles.box10_layout)} />
            <div className={cn(styles.box11, styles.box11_layout)}>
              <>
                <img
                  src={require("assets/total_batteries_icon.png").default}
                  style={{
                    marginLeft: "7px",
                    marginTop: "6px",
                    cursor: "pointer",
                  }}
                />
              </>
            </div>
          </div>
        </div>
        <div className={cn(styles.block8_spacer)} />
        <div className={cn(styles.block8_item1)}>
          <div className={cn(styles.block21, styles.block21_layout)}>
            <div className={cn(styles.block22, styles.block22_layout)}>
              <h3 className={cn(styles.subtitle2, styles.subtitle2_layout)}>
                {header?.batteryserial}
              </h3>
            </div>
            <div
              className={cn(
                styles.small_text_body1,
                styles.small_text_body1_layout
              )}
            >
              {"Date of purchase"}
            </div>
            <div
              className={cn(
                styles.small_text_body1,
                styles.small_text_body1_layout1
              )}
            >
              {purchaseDate && purchaseDate[0]}
            </div>
          </div>
        </div>
        <div className={cn(styles.block8_spacer1)} />
        <div className={cn(styles.block8_item2)}>
          <div className={cn(styles.block9, styles.block9_layout)}>
            <div className={cn(styles.block9_item)}>
              <div className={cn(styles.block10, styles.block10_layout)}>
                <div className={cn(styles.flex2, styles.flex2_layout)}>
                  <div
                    className={cn(
                      styles.small_text_body11,
                      styles.small_text_body11_layout
                    )}
                  >
                    {"SOC"}
                  </div>
                  <div className={cn(styles.flex2_spacer)} />
                  <div
                    className={cn(
                      styles.small_text_body12,
                      styles.small_text_body12_layout
                    )}
                  >
                    {`${socHeaderValue}%`}
                  </div>
                </div>

                <div className={cn(styles.group, styles.group_layout)}>
                  <div
                    className={cn(
                      styles.small_text_body,
                      styles.small_text_body_layout
                    )}
                  >
                    {batteryStatus === "0"
                      ? "Fault"
                      : batteryStatus === "1"
                      ? "Charging"
                      : batteryStatus === "2"
                      ? "Charged"
                      : batteryStatus === "3"
                      ? "Under maintainance"
                      : batteryStatus === "4"
                      ? "In field"
                      : ""}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={cn(styles.block8_spacer2)}>
          <div className={cn(styles.vertical_line_layout)}></div>
        </div>

        <div className={cn(styles.block8_item3)}>
          <div className={cn(styles.block14, styles.block14_layout)}>
            <div className={cn(styles.block14_item)}>
              <div className={cn(styles.block15, styles.block15_layout)}>
                <div className={cn(styles.block13, styles.block13_layout)}>
                  <div
                    className={cn(
                      styles.small_text_body13,
                      styles.small_text_body13_layout
                    )}
                  >
                    {"Estimated Range"}
                  </div>
                  <div className={cn(styles.block13_spacer)} />
                  <div
                    className={cn(
                      styles.small_text_body14,
                      styles.small_text_body14_layout
                    )}
                  >
                    {header.range}
                  </div>
                </div>

                <div className={cn(styles.block16, styles.block16_layout)}>
                  <div className={cn(styles.box8, styles.box8_layout)} />
                </div>
              </div>
            </div>
            <div className={cn(styles.block14_item1)}>
              <div
                style={{
                  "--src": `url(${
                    require("assets/fb8090d11af04cb5284c051719391885.png")
                      .default
                  })`,
                }}
                className={cn(styles.image2, styles.image2_layout)}
              />
            </div>
          </div>
        </div>
        <div className={cn(styles.block8_spacer2)}>
          <div className={cn(styles.vertical_line_layout)}></div>
        </div>

        <div className={cn(styles.block8_item4)}>
          <div className={cn(styles.block11, styles.block11_layout)}>
            <div className={cn(styles.block11_item)}>
              <div className={cn(styles.block12, styles.block12_layout)}>
                <div className={cn(styles.block13, styles.block13_layout)}>
                  <div
                    className={cn(
                      styles.small_text_body15,
                      styles.small_text_body15_layout
                    )}
                  >
                    {"Latitude"}
                  </div>
                  <div className={cn(styles.block13_spacer)} />
                  <div
                    className={cn(
                      styles.small_text_body16,
                      styles.small_text_body16_layout
                    )}
                  >
                    {header.latitude}
                  </div>
                </div>

                <div className={cn(styles.block13, styles.block13_layout1)}>
                  <div
                    className={cn(
                      styles.small_text_body17,
                      styles.small_text_body17_layout
                    )}
                  >
                    {"Longitude"}
                  </div>
                  <div className={cn(styles.block13_spacer)} />
                  <div
                    className={cn(
                      styles.small_text_body18,
                      styles.small_text_body18_layout
                    )}
                  >
                    {header.longitude}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={cn(styles.block8_spacer2)}>
          <div className={cn(styles.vertical_line_layout)}></div>
        </div>
        <div className={cn(styles.block8_item5)}>
          <div className={cn(styles.block17, styles.block17_layout)}>
            <div className={cn(styles.block18, styles.block18_layout)}>
              <div
                className={cn(
                  styles.small_text_body19,
                  styles.small_text_body19_layout
                )}
              >
                {"Cycle life"}
              </div>
              <div className={cn(styles.block18_spacer)} />
              <div
                className={cn(
                  styles.small_text_body110,
                  styles.small_text_body110_layout
                )}
              >
                {`${header.cycleLife}`}
              </div>
            </div>

            <div className={cn(styles.block19, styles.block19_layout)}>
              <div className={cn(styles.block19_item)}>
                <div className={cn(styles.block20, styles.block20_layout)}>
                  <div
                    className={cn(
                      styles.cover_block,
                      styles.cover_block_layout
                    )}
                  >
                    <div
                      className={cn(
                        styles.small_text_body3,
                        styles.small_text_body3_layout
                      )}
                    >
                      {"35%"}
                    </div>
                  </div>
                </div>
              </div>
              <div className={cn(styles.block19_spacer)} />
              <div
                className={cn(
                  styles.small_text_body2,
                  styles.small_text_body2_layout
                )}
              >
                {"100%"}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={cn(styles.horizontal_line_spacer)}>
        <div className={cn(styles.horizontal_line_layout)}></div>
      </div>

      <div className={cn(styles.flex3, styles.flex3_layout)}>
        {/* tab, setTab */}

        <h3
          className={
            tab === 1
              ? cn(styles.subtitle, styles.subtitle_layout)
              : cn(styles.subtitle1, styles.subtitle1_layout)
          }
          onClick={() => {
            setTab(1);
          }}
        >
          {"Analytics"}
        </h3>
        <div className={cn(styles.flex3_spacer)} />
        <h3
          className={
            tab === 2
              ? cn(styles.subtitle, styles.subtitle_layout)
              : cn(styles.subtitle1, styles.subtitle1_layout)
          }
          onClick={() => {
            setTab(2);
          }}
        >
          {"Battery Information"}
        </h3>
        <div className={cn(styles.flex3_spacer1)} />
        <h3
          className={
            tab === 3
              ? cn(styles.subtitle, styles.subtitle_layout)
              : cn(styles.subtitle1, styles.subtitle1_layout)
          }
          onClick={() => {
            setTab(3);
          }}
        >
          {"Swapping History"}
        </h3>
        <div className={cn(styles.flex3_spacer1)} />
        <h3
          className={
            tab === 4
              ? cn(styles.subtitle, styles.subtitle_layout)
              : cn(styles.subtitle1, styles.subtitle1_layout)
          }
          onClick={() => {
            setTab(4);
          }}
        >
          {"Battery Tracking"}
        </h3>
      </div>

      {/* component start here */}
      {tab === 1 ? (
        <BatteryAnalytics id={batteryId} />
      ) : tab === 4 ? (
        <BatteryTracking batterySerial={batterySerial} />
      ) : tab === 2 ? (
        <BatteryInformation id={batteryId} />
      ) : (
        <BatterySwappingHistory id={batteryId} />
      )}

      {/* component ends here */}
    </div>
  );
}

export default function Battery(props) {
  const batteryId = props.match.params.id;
  const batterySerial = props.match.params.batterySerial;
  const batteryName = props.match.params.batteryName;
  let Urls = window.location.href.toString().split(window.location.host)[1];
  return (
    <>
      <Master
        opts={props}
        screen={BatteryView}
        showStatus={true}
        batteryId={batteryId}
        batterySerial={batterySerial}
        batteryName={Urls}
      />
    </>
  );
}

Battery.inStorybook = true;
